"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const classnames_1 = __importDefault(require("classnames"));
const documentUtil_1 = __importDefault(require("helpers/documentUtil"));
const body_1 = __importDefault(require("./body"));
const footer_1 = __importDefault(require("./footer"));
const header_1 = __importDefault(require("./header"));
const modalContext_1 = require("./modalContext");
require("@hotmart/cosmos/dist/modal");
const modal_module_scss_1 = __importDefault(require("./modal.module.scss"));
const MODAL_PORTAL_ID = 'app-club-admin-modals-container';
const modalRoot = documentUtil_1.default.createElement(MODAL_PORTAL_ID);
const Modal = ({ children, show, onClose, 'data-test': dataTest, centered = true, docked = false, className = '', blockBackdropClick = false, ...rest }) => {
    const [modalRef, setModalRef] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!show) {
            modalRef === null || modalRef === void 0 ? void 0 : modalRef.closeModal();
            return;
        }
        modalRef === null || modalRef === void 0 ? void 0 : modalRef.openModal();
    }, [show, modalRef]);
    (0, react_1.useEffect)(() => {
        onClose && (modalRef === null || modalRef === void 0 ? void 0 : modalRef.addEventListener('close', onClose));
        return () => onClose && (modalRef === null || modalRef === void 0 ? void 0 : modalRef.removeEventListener('close', onClose));
    }, [onClose, modalRef]);
    if (!show) {
        return null;
    }
    const classes = (0, classnames_1.default)({
        'hot-dropdocked': docked,
        [modal_module_scss_1.default.blockBackdropClick]: blockBackdropClick
    }, [modal_module_scss_1.default.disableCloseButton], className);
    return (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)(modalContext_1.ModalProvider, { onClose: onClose, children: (0, jsx_runtime_1.jsx)("hot-modal", { ref: setModalRef, class: classes, "data-test": dataTest, role: "dialog", ...(centered && { position: 'centered' }), ...rest, children: children }) }), modalRoot);
};
Modal.Header = header_1.default;
Modal.Body = body_1.default;
Modal.Footer = footer_1.default;
exports.default = Modal;
